angular.module('leanlaw').directive('smallCalendar', ["$document", "$window", "$rootScope", "leanLawApi", "userService", function ($document, $window, $rootScope, leanLawApi, userService) {
  return {
    restrict: 'E',
    scope: {
      today: "=",
      onDayChange: "&?",
      highlightDates: "="
    },
    template: require('./views/smallCalendar.html'),
    link: function ($scope, element, attrs, ctrl) {
      // Array of days to display, including prev/next month
      $scope.days = [];
      $scope.today = $scope.today || new Date();
      $scope.totalHours = 0.0;
      $scope.billableHours = 0.0;
      $scope.nonBillableHours = 0.0;
      $scope.fixedFeeHours = 0.0;
      var entrySaveEvent = "planner-entry-saved";

      // Returns the number of days in the month of the specified date
      // https://stackoverflow.com/questions/1184334
      var getMonthDays = function getMonthDays(date) {
        var d = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return d.getDate();
      };
      var getPrevMonth = function getPrevMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() - 1);
      };
      var getStartDate = function getStartDate(date) {
        return new Date(date.getFullYear(), date.getMonth(), 0);
      };
      // Returns the day of the week on which the month starts
      var getStartDay = function getStartDay(date) {
        return getStartDate(date).getDay();
      };

      // Returns true if the dates match
      var compareDates = function compareDates(date, compare) {
        if (date.getFullYear() !== compare.getFullYear()) return false;
        if (date.getMonth() !== compare.getMonth()) return false;
        if (date.getDate() !== compare.getDate()) return false;
        return true;
      };

      // Returns true if the date is highlighted
      var isHighlighted = function isHighlighted(date) {
        for (var i = 0; i < $scope.highlightDates.length; i++) {
          if (compareDates($scope.highlightDates[i], date)) return true;
        }
        return false;
      };

      // Loads heatmap data and caches the report
      var heatmapReport;
      var loadHeatmap = function loadHeatmap() {
        if (!$scope.days.length) return;

        // Determine the start and end dates for this calendar view
        var startingDayIndex = _.findIndex($scope.days, {
          isOther: false
        });
        var startDate = $scope.days[startingDayIndex].date;

        // There was some logic here that received the endDate by looking up findLastIndex of
        // $scope.days but in some cases it ended up requesting four months. Not clear why
        // but just adding a month to the startDate guarantees that we only request one month
        var startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        var endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);
        var startString = startDate.toNetworkDate();
        var endString = endDate.toNetworkDate();
        userService.me().then(me => {
          leanLawApi.getReport({
            primary: "period",
            data: "hours",
            period: "day",
            billed: "any",
            source: 'client',
            startDate: startString,
            endDate: endString,
            account: $scope.$parent.plannerAccount ? $scope.$parent.plannerAccount.id : me.id,
            scope: "all"
          }).then(report => {
            heatmapReport = report;
            $scope.totalHours = report.data.hours.total;
            $scope.billableHours = me.company.settings?.adjustments ? report.data.hours.trackedHours : report.data.hours.billable;
            $scope.nonBillableHours = report.data.hours.nonBillable;
            $scope.fixedFeeHours = report.data.hours.charges;
            applyHeatmap();
          }).catch(err => {
            console.log(err);
          });
        });
      };

      // Applies the loaded heatmap
      var applyHeatmap = function applyHeatmap() {
        var report = heatmapReport;
        for (var i = 0; i < $scope.days.length; i++) {
          $scope.days[i].relHours = 0.0;
        }

        // What a full bar represents to the user
        var maxHours = 8;
        if (!report.periods) return;
        // for (var i = 0; i < report.periods.length; i++) {
        //     var period = report.periods[i];
        //
        //     var hours = period.data.hours.total;
        //     if (hours == 0) return;
        //
        //     // Calculate day boundaries for this period
        //     var sd = new Date(period.period.startDate).getTime();
        //     var ed = new Date(period.period.endDate).getTime();
        //     // Find the day which matches the date range
        //     var matchingDateIdx = $scope.days.findIndex(element => {
        //         if (!element.date) return false;
        //         var time = element.date.getTime();
        //         // Find the element that is in the matching date range
        //         return (sd <= time && time < ed);
        //     });
        //
        //     // Skip when request comes back after a month has already changed
        //     if (matchingDateIdx === -1) return;
        //
        //     // Calculate + clamp ratio
        //     var ratio = period.data.hours.total / maxHours;
        //     $scope.days[matchingDateIdx].relHours = Math.min(ratio, 1.0);
        // }
        report.periods.forEach(period => {
          var hours = period.data.hours.total;
          if (hours == 0) return;

          // Calculate day boundaries for this period
          var sd = new Date(period.period.startDate).getTime();
          var ed = new Date(period.period.endDate).getTime();
          // Find the day which matches the date range
          var matchingDateIdx = $scope.days.findIndex(element => {
            if (!element.date) return false;
            var time = element.date.getTime();
            // Find the element that is in the matching date range
            return sd <= time && time < ed;
          });

          // Skip when request comes back after a month has already changed
          if (matchingDateIdx === -1) return;

          // Calculate + clamp ratio
          var ratio = period.data.hours.total / maxHours;
          $scope.days[matchingDateIdx].relHours = Math.min(ratio, 1.0);
        });
      };

      // Populate days array
      $scope.updateCalendar = function updateCalendar(date) {
        $scope.days = [];

        // Fill in the days leading up to this month
        var startingDay = getStartDay(date);
        var prevMonth = getPrevMonth(date);
        var prevMonthDays = getMonthDays(prevMonth);
        for (var i = 0; i <= startingDay; i++) {
          // Determine which day to place in calendar array
          var dayOffset = startingDay - i;
          var day = prevMonthDays - dayOffset;
          $scope.days.push({
            day: day,
            isOther: true
          });
        }

        // Clear out whole empty weeks prior to this month
        if (!($scope.days.length % 7)) {
          $scope.days = [];
        }

        // Current month
        var curMonthDays = getMonthDays(date);
        for (var i = 1; i <= curMonthDays; i++) {
          var activeDate = new Date($scope.today);
          activeDate.setDate(i);
          $scope.days.push({
            day: i,
            date: activeDate,
            isActive: isHighlighted(activeDate),
            isToday: compareDates(new Date(), activeDate),
            isFuture: activeDate.getTime() > new Date().getTime(),
            isOther: false
          });
        }

        // // Finish calendar days
        // var expectedDays = 7 * 6; // Show at most 6 weeks
        // var remainingDays = expectedDays - $scope.days.length;
        // // Ensure that there isn't a whole week belonging to the
        // // next month in the calendar
        // if (remainingDays >= 7) {
        //     remainingDays -= 7;
        // }
        // // Fill in next month's days
        // for (var i = 0; i < remainingDays; i++) {
        //     $scope.days.push({
        //         day: i+1,
        //         isOther: true
        //     });
        // }
        return $scope.days;
      };
      function daysInMonth(year, month) {
        return new Date(year, month, 0).getDate();
      }
      $scope.selectDate = function selectDate(date) {
        // New copy of date to prevent original date being modified.
        let newDate = new Date(date);
        if (!$scope.days.length) return;
        // Don't select past end of the month
        var days = daysInMonth($scope.today.getFullYear(), $scope.today.getMonth() + 1);
        var endDate = new Date($scope.today.getFullYear(), $scope.today.getMonth() + 1, days + 1);
        endDate.setHours(23);
        endDate.setMinutes(59);
        if (newDate.getTime() > endDate.getTime()) return;
        $scope.today = new Date(newDate);
        if ($scope.onDayChange) $scope.onDayChange()(newDate);
      };

      // Watch for changes on today value
      $scope.$watch("today", function (newValue, oldValue) {
        $scope.updateCalendar(newValue);
        // // Only load the heatmap when the month changes
        // if (newValue.getMonth() == oldValue.getMonth())
        //     return applyHeatmap();
        // Load heatmap data on month change only
        loadHeatmap();
      }, true);
      $scope.$watch("highlightDates", function (newValue) {
        $scope.updateCalendar($scope.today);
        applyHeatmap();
      }, true);
      $scope.$parent.$watch("plannerAccount", function (newValue) {
        heatmapReport = {};
        loadHeatmap();
      }, true);

      // Update heatmap when entry is changed
      $rootScope.$on(entrySaveEvent, function () {
        loadHeatmap();
      });
    }
  };
}]);